import { ResizeObserver as Polyfill } from '@juggle/resize-observer';
const ResizeObserver = window.ResizeObserver || Polyfill;

import './responsive-nav-bar.scss';

class NavBar {
    constructor(el) {

        // store for later
        this.el = el;
        this.mask = el.querySelector('.responsive-nav-bar--ul-mask');
        this.content = el.querySelector('ul');
        this.prevBtn = el.querySelector('.responsive-nav-bar--button.previous');
        this.nextBtn = el.querySelector('.responsive-nav-bar--button.next');
        this.tabbedContent = el.classList.contains('responsive-nav-bar--tabbed-content');
        this.scrollMode = false;
        this.offsetIndex = 0;
        this.focusIndex = 0;
        this.activeIndex = 0;
        this.offset = 0;
        this.resizeRequested = false;
        this.resizeTimeout = null;
        this.touchStartX = null;
        this.swipeThreshold = 60;

        // get links in nav bar
        this.items = [...el.querySelectorAll('.nav-item a')];
        this.itemsCount = this.items.length;

        // loop through links / get active index
        for(let x= 0; x < this.itemsCount; x++) {
            if(this.items[x].classList.contains('active')) {
                this.offsetIndex = x;
                this.focusIndex = x;
                this.activeIndex = x;
            }
            this.items[x].addEventListener('click', () => {
                this.setActive(x);
            });
        }

        // buttons
        this.prevBtn.addEventListener('click', () => {
            this.offsetMove(false);
        });
        this.nextBtn.addEventListener('click', () => {
            this.offsetMove(true);
        });

        // keyboard nav
        this.el.addEventListener('keydown', (e) => {
            switch (e.key) {
                // next item (no looping)
                case 'Right':
                case 'ArrowRight':
                    e.preventDefault();
                    this.focusMove(true);
                    break;
                // previous item (no looping)
                case 'Left':
                case 'ArrowLeft':
                    e.preventDefault();
                    this.focusMove(false);
                    break;
                // SPACE/ENTER/RETURN to click a item
                case 'Spacebar':
                case ' ':
                case 'Enter':
                case 'Return':
                    e.preventDefault();
                    this.items[this.focusIndex].click();
                    break;
            }
        });

        // swiping
        this.mask.ontouchstart = (e) => {
            if (e.touches.length == 1) {
                let touch = e.touches[0];
                this.touchStartX = touch.pageX;
            }
        };
        this.el.ontouchmove = (e) => {
            if (this.touchStartX != null) {
                e.preventDefault();
                let touchCurrentX = e.changedTouches[0].pageX;
                if ((touchCurrentX - this.touchStartX) > this.swipeThreshold) {
                    this.touchStartX = null;
                    this.offsetMove(false);
                } else if ((this.touchStartX - touchCurrentX) > this.swipeThreshold) {
                    this.touchStartX = null;
                    this.offsetMove(true);
                }
            }
        };
        this.el.ontouchend = () => {
            this.touchStartX = null;
        };

        // add resize observer
        this.ro = new ResizeObserver(() => {
            if(!this.resizeRequested) {
                this.resizeRequested = true;
                this.resizeTimeout = setTimeout(() => {
                    this.resize();
                    this.resizeRequested = false;
                    this.resizeTimeout = null;
                }, 200);
            }
        });
        this.ro.observe(this.el); // Watch dimension changes wrapping element

    }

    offsetMove(mode) {
        let prevIndex = this.offsetIndex;
        if(mode && this.offsetIndex < (this.itemsCount-1)) {
            this.offsetIndex = this.offsetIndex + 1;
        } else if(!mode && this.offsetIndex > 0) {
            this.offsetIndex = this.offsetIndex - 1;
        }
        if(prevIndex !== this.offsetIndex) {
            this.updateOffset();
        }
    }

    focusMove(mode) {
        let prevIndex = this.focusIndex;
        if(mode && this.focusIndex < (this.itemsCount-1)) {
            this.focusIndex = this.focusIndex + 1;
        } else if(!mode && this.focusIndex > 0) {
            this.focusIndex = this.focusIndex - 1;
        }
        if(prevIndex !== this.focusIndex) {
            this.items[this.focusIndex].setAttribute('tabIndex','0');
            this.items[this.focusIndex].focus();
            this.items[prevIndex].setAttribute('tabIndex','-1');
            this.offsetIndex = this.focusIndex;
            this.updateOffset();
        }
    }

    setActive(newIndex) {
        if(newIndex != this.activeIndex) {
            if(!this.tabbedContent) this.items[this.activeIndex].classList.remove('active');
            this.items[this.activeIndex].setAttribute('tabIndex','-1');
            this.activeIndex = newIndex;
            this.focusIndex = newIndex;
            if(!this.tabbedContent) this.items[this.activeIndex].classList.add('active');
            this.items[this.activeIndex].setAttribute('tabIndex','0');
        }
    }

    resize() {
        if(this.content.offsetWidth > this.mask.offsetWidth) {
            if(!this.scrollMode) {
                this.scrollMode = true;
                this.el.classList.add('scroll');
            }
            this.updateOffset();
        } else {
            if(this.scrollMode) {
                this.scrollMode = false;
                this.el.classList.remove('scroll');
                this.offset = 0;
                this.content.style.transform = 'translateX(0)';
            }
        }
    }

    updateOffset() {
        if(this.scrollMode) {
            let itemLeft = this.items[this.offsetIndex].offsetLeft,
                maskWidth = this.mask.offsetWidth,
                contentWidth = this.content.offsetWidth,
                offsetMax = contentWidth - maskWidth;
            this.offset = itemLeft > offsetMax ? offsetMax : itemLeft;
            this.content.style.transform = 'translateX(-' + this.offset + 'px)';
            // update buttons status
            this.prevBtn.disabled = this.offsetIndex == 0;
            this.nextBtn.disabled = this.offset >= offsetMax;
        }
    }
}

// export the default function to create
export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new NavBar(node);
        }
    });
}